export enum HistoryFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  startDate = 'startDate',
  endDate = 'endDate',
  actionTypes = 'actionTypes',
}
